import React from 'react';
import { AppModalTitle } from 'components/modal/AppModal.styled';
import { InstallationTutoModalWrapper } from 'components/modal/installation/InstallationTutoModal.styled';
import Button from 'components/common/button/Button';

export interface InstallationTutoModalProps {
  title?: string;
  steps?: Array<string>;
  message?: string;
  // Button shown under the message (e.g. opens the browser's install dialog)
  action?: {
    label: string;
    onClick: () => void;
  };
}

const InstallationTutoModal: React.FC<InstallationTutoModalProps> = ({
  title,
  steps,
  message,
  action,
}) => {
  return (
    <InstallationTutoModalWrapper>
      {title && <AppModalTitle>{title}</AppModalTitle>}
      {!!steps?.length && (
        <ul>
          {steps.map((step, index) => {
            return (
              <li
                key={`step-${index}`}
                dangerouslySetInnerHTML={{
                  __html: step,
                }}
              />
            );
          })}
        </ul>
      )}
      {message && (
        <p
          className={!title ? 'msg-only' : ''}
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        />
      )}
      {action && (
        <div className="action">
          <Button color="white" expand onClick={action.onClick}>
            {action.label}
          </Button>
        </div>
      )}
    </InstallationTutoModalWrapper>
  );
};

export default InstallationTutoModal;
